import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";

const partnersBaseController = "api/partners";


// Get all partners
export const getAllPartners = async (body = {}) => {
  console.log(body)
  const urlParams = generalFunc.generateUrlParams(body)

  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      let requestString = `/get-all-partners${urlParams}`

      if (body.Filters?.states) requestString += `&FilterOptions.State=${body.Filters?.states}`
      if (body.Filters?.zones) requestString += `&FilterOptions.Zone=${body.Filters?.zones}`
      if (body.Filters?.status) requestString += `&FilterOptions.Status=${body.Filters?.status}`

      const response = await api.get(`${partnersBaseController}${requestString}`);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      throw err;
    }
  }
}


// Get Partner By Id
export const getPartnerById = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${partnersBaseController}/get-partner-by-id?partnerId=${body}`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      throw err;
    }
  }
}


// Create Partner
export const createPartner = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.post(`${partnersBaseController}/create-partner`, body);
      toastr.success('Created partner successfully')
      return response.data.data;

    } catch (err) {
      toastr.error(err.response.data.message)
      throw err;
    }
  }
}

// Activate Partner
export const activatePartner = async id => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${partnersBaseController}/activate-partner/${id}`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Activated partner successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}

// Deactivate Partner
export const deactivatePartner = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {

      const response = await api.patch(`${partnersBaseController}/deactivate-partner/${body}`);
      toastr.success('Deactivated partner successfully')
      return response.data.data;

    } catch (err) {
      toastr.error(err.response.data.message)
      throw err;
    }
  }
}

// Edit Partner
export const editPartner = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.put(`${partnersBaseController}/edit-partner`, body);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Partner Updated Successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      throw err
    }
  }
}

export const exportPartners = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${partnersBaseController}/export-partners`, { responseType: "blob" })
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", `SAED Partners ${generalFunc.getCurrentYear()}.xlsx`)
          document.body.appendChild(link)
          link.click()
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}

export const getPartnersDashboardData = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${partnersBaseController}/get-total-partners-details`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}

export const getAllPartnersWithoutPagination = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${partnersBaseController}/get-all-partners-no-pagination`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}